export const FOLLOWED_USERS_QUERY = `
  query FollowedUsersQuery($userId: ID!, $limit: Int, $after: String) {
    public {
      followedUsers(userId: $userId, limit: $limit, after: $after) {
        edges {
          id
          user {
            id
            isVerified
            nickname
            image {
              id
              url(width: 64, height: 64)
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
